/**
 * États possibles du système de commandes vocales
 */
export type VoiceStatus =
  | 'idle'           // En attente
  | 'recording'      // Enregistrement en cours
  | 'processing'     // Traitement Whisper/GPT
  | 'speaking'       // Lecture TTS
  | 'error';         // Erreur

/**
 * État complet du système vocal
 */
export interface VoiceState {
  status: VoiceStatus;
  transcript: string;
  response: string;
  error: string | null;
  audioLevel: number;        // 0-1, niveau audio en temps réel
  recordingDuration: number; // Durée en secondes
}

/**
 * État initial
 */
export const INITIAL_VOICE_STATE: VoiceState = {
  status: 'idle',
  transcript: '',
  response: '',
  error: null,
  audioLevel: 0,
  recordingDuration: 0
};
